import { Link, useParams } from 'react-router-dom';
import { blogPosts } from '../../../mocks/blogPosts';

const BlogPostHero = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) return null;

  return (
    <div className="relative h-[70vh] min-h-[500px] overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${post.coverImage})` }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
      
      {/* Content */}
      <div className="relative h-full flex items-end">
        <div className="container mx-auto px-6 pb-16">
          {/* Breadcrumb */}
          <nav className="mb-8">
            <Link 
              to="/blog" 
              className="inline-flex items-center text-white/80 hover:text-white transition-colors group"
            >
              <i className="ri-arrow-left-line text-lg mr-2 group-hover:-translate-x-1 transition-transform"></i>
              Back to Blog
            </Link>
          </nav>
          
          {/* Post Meta */}
          <div className="mb-6">
            <span className="inline-block px-4 py-2 bg-gradient-to-r from-teal-500 to-emerald-500 text-white text-sm font-semibold rounded-full mb-4">
              {post.category}
            </span>
            
            <div className="flex items-center text-white/90 text-sm mb-6">
              <img 
                src={post.author.avatar} 
                alt={post.author.name}
                className="w-10 h-10 rounded-full mr-3"
              />
              <span className="mr-4">{post.author.name}</span>
              <span className="mr-4">•</span>
              <span className="mr-4">{new Date(post.date).toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}</span>
              <span className="mr-4">•</span>
              <span>{post.readTime}</span>
            </div>
          </div>
          
          {/* Title */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-4xl">
            {post.title}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default BlogPostHero;